import React from "react";
import { useIntl } from "react-intl";
import EmptyState from "./index";

/**
 * useInvalidLinkCopy
 * @returns {{title: string, description: string, message: string}}
 * @description The one copy for a dead session - a 401, or a status we were never able to fetch.
 * Shared because several surfaces present it (the standalone ToS page, Checkout), and because the
 * `message` that travels to the integrator through `onError` has to say the same thing as the
 * `title`/`description` the user is looking at.
 */
export const useInvalidLinkCopy = () => {
  const { formatMessage } = useIntl();
  return {
    title: formatMessage({
      defaultMessage: "Invalid link",
      description: "Status title",
    }),
    description: formatMessage({
      defaultMessage: "This is usually the result of expired data.",
      description: "Status message",
    }),
    message: formatMessage({
      defaultMessage: "Invalid link.  This is usually the result of expired data.",
      description: "Invalid link. error message",
    }),
  };
};

/**
 * InvalidLinkEmptyState
 * @description The `useInvalidLinkCopy` pair rendered as an EmptyState.
 */
export const InvalidLinkEmptyState = () => {
  const { title, description } = useInvalidLinkCopy();
  return <EmptyState title={title} description={description} />;
};

export default InvalidLinkEmptyState;
